<template>
  <div class="card confirmWindow">
    <h4>
      Weet je zeker dat je {{ item.name }} uit de winkelwagen wilt verwijderen?
    </h4>
    <button class="yes btn btn-blu btn-primary mb-2" @click="$emit('confirm')">
      Ja
    </button>
    <button class="cancel btn btn-light" @click="$emit('cancel')">Nee</button>
  </div>
</template>

<script>
export default {
  props: ["item"],
};
</script>
